var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74707 19.4062H8.24707C4.24707 19.4062 2.24707 18.4062 2.24707 13.4062V8.40625C2.24707 4.40625 4.24707 2.40625 8.24707 2.40625H16.2471C20.2471 2.40625 22.2471 4.40625 22.2471 8.40625V13.4062C22.2471 17.4062 20.2471 19.4062 16.2471 19.4062H15.7471C15.4371 19.4062 15.1371 19.5562 14.9471 19.8062L13.4471 21.8062C12.7871 22.6862 11.7071 22.6862 11.0471 21.8062L9.54707 19.8062C9.38707 19.5862 9.01707 19.4062 8.74707 19.4062Z",
    stroke: "#171719",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24707 8.40625H17.2471",
    stroke: "#171719",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.24707 13.4062H13.2471",
    stroke: "#171719",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComments);
export default __webpack_public_path__ + "static/media/comments.331db29d.svg";
export { ForwardRef as ReactComponent };